import request, { DELETE } from '../../utils/request';

export default data => request('/ala-agreements', { method: DELETE, data });
